import { ICalendarDimensions } from '../containers/BookingCalendar/Calendar/Calendar'
import theme from '../theme/theme'
import wrapRoomName from './text/wrapRoomName'

export default function drawSummaryText(
  ctx: CanvasRenderingContext2D,
  constants: ICalendarDimensions,
  label: string,
) {
  ctx.fillStyle = theme.colors.palette.white
  ctx.fillRect(0, 0, constants.ROOM_WIDTH, constants.SUMMARY_HEIGHT)
  ctx.fillStyle = theme.colors.calendar.gridBorder
  ctx.fillRect(
    constants.ROOM_WIDTH - constants.GRID_BORDER_WIDTH,
    0,
    constants.GRID_BORDER_WIDTH,
    constants.SUMMARY_HEIGHT,
  )
  ctx.fillRect(0, 0, constants.ROOM_WIDTH, constants.GRID_BORDER_WIDTH)
  ctx.font = `400 ${constants.SUMMARY_FONT_SIZE}px Montserrat`
  ctx.fillStyle = 'rgb(0,0,0)'
  ctx.textBaseline = 'top'
  const wrappedLabel = wrapRoomName(ctx, label, constants.ROOM_WIDTH, 2)
  wrappedLabel.forEach((line, idx) => {
    ctx.fillText(
      `${line}`,
      constants.ROOM_PADDING_LEFT,
      (constants.SUMMARY_HEIGHT -
        wrappedLabel.length * constants.SUMMARY_FONT_SIZE) /
        2 +
        idx * constants.SUMMARY_FONT_SIZE,
    )
  })
}
